<!-- <p>edit-study works!</p> -->



<!-- Layout wrapper -->
<div class="layout-wrapper layout-content-navbar">
    <div class="layout-container">
        <!-- Menu -->


        <app-side-nav></app-side-nav>
        <!-- / Menu -->

        <!-- Layout container -->
        <div class="layout-page">
            <!-- Navbar -->

            <!-- / Navbar -->

            <!-- Content wrapper -->
            <div class="content-wrapper">
                <!-- Content -->

                <div class="container-xxl flex-grow-1 container-p-y">


                    <!-- <h4 class="py-3 mb-4"><span class="text-muted fw-light">Study /</span> Study List</h4> -->

                    <!-- <div class="container mt-5"> -->
                   
                    <!-- </div> -->




                    <!-- forms code starts here--------------- -->

<p>edit-study page works!</p>




                <!-- hello -->


                <!-- hello -->
                <hr class="my-5" />
                <!-- </div> -->
                <!-- / Content -->

                <!-- Footer -->
                <!-- <app-footer></app-footer> -->
                <!-- / Footer -->

                <div class="content-backdrop fade"></div>
            </div>
            <!-- Content wrapper -->
        </div>
        <!-- / Layout page -->
    </div>

    <!-- Overlay -->
    <div class="layout-overlay layout-menu-toggle"></div>
</div>